/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createReducer } from 'state/utils';

export default createReducer(null, {
    [actions.CURRENT_USER_RECEIVE]: (state, action) => {
        return get(action, 'user.user.id', null);
    },
});
